{{#foreach virtualSequenceSequencerPath iterationPropertiesList}}
  {{> (partial "snippets/assign-sequencers") virtualSequenceSequencerPath=virtualSequenceSequencerPath handle=handle iterationPropertiesList=iterationPropertiesList.next}}
{{else}}
{{#with handle}}
{{ ../virtualSequenceSequencerPath }}{{ iterationPropertiesList.last.brackets }} = {{ identifier }}{{ iterationPropertiesList.last.brackets }};
{{/with}}
{{/foreach}}
